"use client";
import {
  PiMapTrifoldBold,
  PiCalendarBold,
  PiHeartBold,
  PiStorefrontBold,
  PiForkKnifeBold,
  PiTicketBold,
} from "react-icons/pi";
import { GrShop } from "react-icons/gr";
import { Icon } from "@/components";
import usePersistStore from "@/lib/usePersistStore";
import { useMyShowStore } from "@/lib/persistState";
import { Drawer, MyShowDrawerContent } from "@/components";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useKindeSession } from "@/components/KindeWrapper";
import { useEffect, useState } from "react";
import useStore from "@/lib/state";

export function MobileQuickLinks() {
  const [totalAmount, setTotalAmount] = useState(0);
  const { isMyShowOpen, setIsMyShowOpen } = useStore();

  const myShowStore = usePersistStore(useMyShowStore, (state) => state);

  const myShowbags = myShowStore?.myShowbags || [];
  const myRides = myShowStore?.myRides || [];
  const myEvents = myShowStore?.myEvents || [];
  const myFood = myShowStore?.myFood || [];

  useEffect(() => {
    setTotalAmount(
      myShowbags.length + myRides.length + myEvents.length + myFood.length
    );
  }, [myShowbags, myRides, myEvents, myFood]);

  const { isAuthenticated, user } = useKindeSession();

  const path = usePathname();
  // if path is /map we want to hide the quick links
  if (path === "/map") return null;

  return (
    <div className="flex fixed right-2 bottom-2 left-2 z-50 justify-evenly items-center p-3 px-5 rounded-button-radius shadow-2xl backdrop-blur-md bg-header/90 border-button-radius border-button-width border-button text-header-foreground lg:hidden">
      {/* <QuickLink icon={<PiMapTrifoldBold size={24} />} text="Map" link="/map" /> */}
      {/* <QuickLink
        icon={<PiCalendarBold size={24} />}
        text="Events"
        link="/whats-on"
      /> */}
      <QuickLink
        icon={<PiStorefrontBold size={24} />}
        text="Shop"
        link="/commercial-exhibitors"
      />

      <QuickLink
        icon={<PiCalendarBold size={24} />}
        text="Whats On"
        link="/whats-on"
      />
      <QuickLink
        icon={<PiTicketBold size={24} />}
        text="Buy Tickets"
        link="/buy-tickets"
      />

      <div
        className="flex flex-col flex-1 items-center"
        onClick={() => setIsMyShowOpen(!isMyShowOpen)}
      >
        <PiHeartBold size={24} />
        <p className="text-xs font-bold">My Show</p>
        {totalAmount > 0 && (
          <div className="absolute -top-[20%] flex items-center justify-center w-5 h-5 text-sm rounded-full -right-[60%] bg-button text-button-foreground">
            {totalAmount}
          </div>
        )}
      </div>
    </div>
  );
}

function QuickLink({ icon, text, link }) {
  return (
    <Link href={link} className="flex flex-col flex-1 items-center">
      {icon}
      <p className="text-xs font-bold">{text}</p>
    </Link>
  );
}
